import { Seo, businessSchema } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Contact } from "@/components/home/Contact";

export default function Kontakt() {
  return (
    <>
      <Seo title="Kontakt – Autogarage Siebnen SZ" description="NIVO Garage in Siebnen kontaktieren: Adresse Zürcherstrasse 34, Telefon, WhatsApp und E-Mail. Wir melden uns persönlich." schema={businessSchema} />
      <PageHeader eyebrow="Kontakt" lines={["Wir sind", "für Sie da."]} text="Rufen Sie an, schreiben Sie uns oder senden Sie eine Terminanfrage. Wir melden uns persönlich." />
      <Contact />
    </>
  );
}
